import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../services/storage.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const user = storage.getUser<{ tenantId?: string }>();

  if (user?.tenantId) {
    const tenantReq = req.clone({
      setHeaders: { 'X-Tenant-Id': user.tenantId },
    });
    return next(tenantReq);
  }

  return next(req);
};
